
import React from "react";
import { CSVLink } from "react-csv";
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';


function DownloadSpeciesData(props) {

    const { t } = useTranslation();
   const defaultColumns = [
    {label : `${t('species_table_sub_heading_11')}`, key: "national_distribution_available"},
    {label : `${t('species_table_sub_heading_12')}`, key: "non_molecular_characterization"},
    {label : `${t('species_table_sub_heading_13')}`, key: "molecular_characterization"},
    {label : `${t('species_table_sub_heading_21')}`, key: "in_situ_programme"},
    {label : `${t('species_table_sub_heading_22')}`, key: "number_situ_units"},
    {label : `${t('species_table_sub_heading_23')}`, key: "area_in_situ"},
    {label : `${t('species_table_sub_heading_31')}`, key: "ex_situ_programme"},
    {label : `${t('species_table_sub_heading_32')}`, key: "number_ex_situ"},
    {label : `${t('species_table_sub_heading_33')}`, key: "area_ex_situ"},
    {label : `${t('species_table_sub_heading_34')}`, key: "number_ex_situ_accessions"},
    {label : `${t('species_table_sub_heading_41')}`, key: "national_tree_seed_prog"},
    {label : `${t('species_table_sub_heading_42')}`, key: "tree_breeding_prog"},
    {label : `${t('species_table_sub_heading_43')}`, key: "area_seed_stands"},
    {label : `${t('species_table_sub_heading_44')}`, key: "number_seed_stands"},
    {label : `${t('species_table_sub_heading_45')}`, key: "area_seed_orchards"},
    {label : `${t('species_table_sub_heading_46')}`, key: "number_seed_orchards"},
    {label : `${t('species_table_sub_heading_47')}`, key: "planting_stock_year"},
    {label : `${t('species_table_sub_heading_48')}`, key: "state_tree_breeding_prog"}]

    const columns =  props.page === "all-countries" ? [
{label : `${t('title_region')}`, key: "region"},
{label : props.type === "species" ?  `${t('title_country')}` : `${t('menu_item_species')}`, key: props.type === "species" ?  "country" : "species"},
{label : `${t('menu_item_species')}`, key: "species" },
...defaultColumns
] :
[
  {label : props.type === "species" ?  `${t('title_country')}` : `${t('menu_item_species')}`, key: props.type === "species" ?  "country" : "species"},
...defaultColumns];


const dowloadableData = props.data !== undefined && props.data.length > 0 ?

 props.data.map(

 item => ({ 
            region: item.region,
            species : props.type === "species" ? props.page === "all-countries" ? item.species : props.speciesSelected : item.species,
            country: item.territory, 
            country_label: item.country_label, 
            national_distribution_available: item.national_distribution_available === 1 ? `${t('legend_yes')}` : `${t('legend_no')}`, 
            non_molecular_characterization: item.non_molecular_characterization === 1 ? `${t('legend_yes')}` : `${t('legend_no')}`, 
            molecular_characterization: item.molecular_characterization === 1 ? `${t('legend_yes')}` : `${t('legend_no')}`, 
            in_situ_programme : item.in_situ_programme === 1 ? `${t('legend_yes')}` : `${t('legend_no')}`, 
            number_situ_units: item.number_situ_units,
            area_in_situ: item.area_in_situ,
            ex_situ_programme: item.ex_situ_programme === 1 ? `${t('legend_yes')}` : `${t('legend_no')}`,
            number_ex_situ: item.number_ex_situ, 
            area_ex_situ : item.area_ex_situ,
            number_ex_situ_accessions: item.number_ex_situ_accessions,
            national_tree_seed_prog: item.national_tree_seed_prog === 1 ? `${t('legend_yes')}` : `${t('legend_no')}`,
            tree_breeding_prog: item.tree_breeding_prog === 1 ? `${t('legend_yes')}` : `${t('legend_no')}`,
            area_seed_stands: item.area_seed_stands,
            number_seed_stands: item.number_seed_stands,
            area_seed_orchards: item.area_seed_orchards,
            number_seed_orchards: item.number_seed_orchards,
            planting_stock_year: item.planting_stock_year,
            state_tree_breeding_prog: item.state_tree_breeding_prog
          
          
          
          })
) : [];
        


  return (
    <div>
      <CSVLink data={dowloadableData} headers={columns} filename={props.type === "species" ? props.page === "all-countries" ? "all_species" : `${props.speciesSelected !== null && props.speciesSelected !== undefined ? props.speciesSelected : ""}_Silvagris.csv` : `Silvagris_${props.country !== undefined ? props.country.replaceAll(' ', '_')
         : ""}_species.csv`}>
      <Button  style={{backgroundColor: "#116AAB",  border:"1px solid #116AAB", width: props.page === "countryPage" ? "300px" : ''}}>
      <span style={{marginLeft: "0.5rem", marginRight: "0.5rem", verticalAlign: "middle"}}>{props.page === "countryPage" ? t('download_species_data') : t('button_download')}</span>
      {/* <img style={{verticalAlign: "middle"}} src={process.env.PUBLIC_URL + `/img/download.svg`} alt="download" /> */}
      </Button>
      </CSVLink>
    </div>
  );
}
export default DownloadSpeciesData;